import React, { lazy, Suspense, useEffect } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Outlet,
} from "react-router-dom";
import Fallback from "../Fallback";
import { useTranslation } from 'react-i18next';
import SignIn from "./SignIn";
import ConfirmSignup from "./ConfirmSignup";
import { Link } from "@mui/material";
import { toast } from "react-toastify";
import {
  captureMarketplaceReturnUrl,
  MARKETPLACE_RETURN_URL_PARAM,
} from "../../services/marketplace-install";
import BrandLogo from "../../components/BrandLogo";
import { BRAND } from "../../services/brand";

const AuthLayout = (props: any) => {
  const { t } = useTranslation();

  useEffect(() => {
    captureMarketplaceReturnUrl(window.location.search);
    const url = new URL(window.location.href);
    if (url.searchParams.has(MARKETPLACE_RETURN_URL_PARAM)) {
      url.searchParams.delete(MARKETPLACE_RETURN_URL_PARAM);
      window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
    }
    if (url.searchParams.get("unauthorized") === "true") {
      url.searchParams.delete("unauthorized");
      window.history.replaceState({}, "", `${url.pathname}${url.search}${url.hash}`);
      toast(t("general.unauthorized") as string, { type: "warning" });
    }
  }, [t]);

  return (
    <>
      <meta name="robots" content="noindex, nofollow" />
      <div
        className="min-h-[100%] container mx-auto pt-24 pb-8 flex flex-col justify-between px-8 md:px-0"
        style={{ maxWidth: 445 }}
      >

        <div>
          <div className="flex justify-start">
            <a href="/" className="mb-8">
              <BrandLogo className="w-72 h-16 object-contain mb-4" />
            </a>
          </div>
          <Outlet />
        </div>
        <div className="flex flex-col justify-center items-center">
          <p className="text-xxs">{`©${new Date().getFullYear()} ${BRAND.name}, Inc. ${t('footer.rights_reserved')}.`}</p>
          <Link
            href={`${BRAND.websiteUrl}/terms/`}
            target="_blank"
            rel="noopener noreferrer"
            className="text-link text-xs font-semibold no-underline hover:underline"
          >
            {t('footer.privacy')}
          </Link>
        </div>
      </div>
    </>
  );
};

const AuthPage = () => {
  const Login = lazy(() => import("./Login"));
  const ForgotPassword = lazy(() => import("./ForgotPassword"));
  return (
    <Routes>
      <Route element={<AuthLayout />}>
        <Route path="login" element={
          <Suspense fallback={<Fallback />}>
            <Login />
          </Suspense>
        } />
        <Route path="sign-up" element={
          <Suspense fallback={<Fallback />}>
            <SignIn />
          </Suspense>
        } />
        <Route path="confirm-sign-up" element={
          <Suspense fallback={<Fallback />}>
            <ConfirmSignup />
          </Suspense>
        } />
        <Route path="forgot-password" element={
          <Suspense fallback={<Fallback />}>
            <ForgotPassword />
          </Suspense>
        } />
        <Route index element={
          <Suspense fallback={<Fallback />}>
            <Login />
          </Suspense>
        } />
      </Route>
    </Routes>
  )
};

export default AuthPage;
